// 查询卡片的配置值
import { apiGetapprovalreportpreviewGrid } from '@/port/admins/report'
import {apiGetapprovalreport} from "../../../../port/admins/report";
import { getWeek } from '@/api/styleUtils'
import { getUserMoreInfo } from "@/components/common/card/js/util.card.js";
import { sortObjectsByField } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { cloneDeep } from 'lodash'

export const getConfig = async ({cardConfig, fromdatas = [], curpage, pagesize, appid}) => {
  console.log('查询卡片配置', cardConfig, fromdatas, curpage, pagesize, appid)
  const valObj = {}
  const item = cardConfig.configList[cardConfig.activeConfig].children
  const formList = cardConfig.dataSource.formList || []
  const obj = {}

  for (const i of item) {
    if (i.appid && i.appid !== appid) {
      if (!obj[i.appid]) obj[i.appid] = []
      obj[i.appid].push(i)
    }
  }
  // 查询对标表的值
  for (const i in obj) {
    // 获取到传参配置
    const s = formList.findIndex(its => Number(its.appid) === Number(i))
    if (s === -1) continue
    const parameterConfiguration = formList[s].parameters || []
    let fields = []
    let select = []
    const where = []

    // parameterConfiguration 这边的是所有的传参设置，走一次数据
    for (const sa of parameterConfiguration) {
      // 传参配置的值也需要放进去一起走筛选逻辑
      fields.push(sa.chooseFrom.fatherType)
      select.push(sa.chooseFrom.revisabilityName || sa.chooseFrom.name)

      const name = (sa.from.revisabilityName || sa.from.name || '').split('.').join('')
      const title = sa.from.title
      const type = sa.from.type
      if (!valObj[name]) {
        const ars = []
        fromdatas.forEach(its => {
          const val = its[name] || its[title] || its[title + '_' + type]
          if (Array.isArray(val)) {
              ars.push(...val)
            } else {
              ars.push(val)
            }
          }
        )
        valObj[name] = Array.from(new Set(ars))
      }
      let value = valObj[name]
      if (Array.isArray(value)) {
        value = value.filter(item => { return item || item === 0 })
      }
      where.push({
        relation: 'in',
        value: value,
        field: formList[s].datatype === 2 ? (sa.chooseFrom.revisabilityName || sa.chooseFrom.name) : sa.chooseFrom.fatherType
        // field: sa.chooseFrom.revisabilityName
      })
    }
    for (const s of obj[i] || []) {
      fields.push(s.fatherType)
      select.push(s.revisabilityName || s.name)
      // 对标传参值查询
    }
    // 去重
    fields = Array.from(new Set(fields))
    select = Array.from(new Set(select))

    const source = {
      type: 'source',
      dataconfig: {
        formid: Number(i),
        fields: fields,
        select: fields
        // select: select
      },
      id: 123, // 随便写的，可以直接改
      parentid: [],
      approvalId: Number(i)
    }
    let reportArr = []
    let filterId = [123]
    // 如果是仪表盘的话另外走
    if (formList[s].datatype === 2) {
      const reportRes = await apiGetapprovalreport({ approvalReportId: formList[s].appid }).catch(err => { console.log(err) })
      console.log('另外走1', reportRes)
      if (reportRes.code === 0) {
        const config = JSON.parse(reportRes.data.config)
        // 找到 数据呈现 并且通过 数据呈现获取到倒数那个节点
        const outputIndex = config.findIndex(its => its.type === 'output')
        if (outputIndex !== -1) {
          filterId = config[outputIndex].parentid
          config.splice(outputIndex, 1)
          reportArr = config
        }
      }
    }
    const fieldSys = {
      type: 'filter',
      fileConfig: 'and',
      dataconfig: {
        rel: 'and',
        where: where
      },
      id: 124,
      parentid: filterId // source 的id
    }
    const obs = {
      curpage: 1,
      pagesize: 999999,
      // curpage: curpage,
      // pagesize: pagesize,
      nodeId: 124,
      config: formList[s].datatype === 2 ? [...reportArr, fieldSys] : [source, fieldSys]
    }
    const res = await apiGetapprovalreportpreviewGrid(obs).catch(err => { console.log(err) })
    console.log('另外走2', res)
    if (res.code === 0) {
      fromdatas = comparison({
        parameters: parameterConfiguration,
        fromdatas: fromdatas,
        target: res.data,
        field: obj[i],
        datatype: formList[s].datatype
      })
    }
  }
  // 返回其他数据的联系人
  let canvasChildren = []
  if (cardConfig && cardConfig.configList) {
    canvasChildren = cardConfig.configList[0].children
    fromdatas = await getUserMoreInfo(cloneDeep(fromdatas), canvasChildren)
  }
  return fromdatas
}

/**
 * parameters // 传参条件
 * fromdatas  // 本表数据
 * target     // 目标表数据
 * field      // 合并字段
 * datatype   // 选择表类型 1 表单 2 工坊
 * */
function comparison ({ parameters = [], fromdatas = [], target = [], field = [], datatype = 1 }) {
  if (target.length === 0 || fromdatas.length === 0) return fromdatas
  for (let i = 0; i < fromdatas.length; i++) {
    const item = fromdatas[i]
    // 查询是否满足条件
    let condition = JSON.parse(JSON.stringify(target))
    for (const s of parameters) {
      // 查询本表的传参条件是什么,再查询匹配数据
      const from = (s.from.revisabilityName || s.from.name || '').split('.').join('')
      let fromArr
      if (item[from]) {
        fromArr = item[from]
        if (Array.isArray(fromArr)) {
          if (fromArr[0] && (fromArr[0].userId || fromArr[0].realname || fromArr[0].name)) {
            fromArr = fromArr.map(user => { return user.userId || user.realname || user.name }).join()
          }
        }
      }
      const fromKey = s.from.title + '_' + s.from.type
      let fromKeyArr
      if (item[fromKey]) {
        fromKeyArr = item[fromKey]
        if (Array.isArray(fromKeyArr)) {
          if (fromKeyArr[0] && (fromKeyArr[0].userId || fromKeyArr[0].realname || fromKeyArr[0].name)) {
            fromKeyArr = fromKeyArr.map(user => { return user.userId || user.realname || user.name }).join()
          }
        }
      }
      const chooseFrom = datatype === 2 ? (s.chooseFrom.revisabilityName || s.chooseFrom.name) : s.chooseFrom.fatherType
      const chooseKey = s.chooseFrom.title + '_' + s.chooseFrom.type
      condition = condition.filter(its => {
        let chooseFromValue = its[chooseFrom] || its[chooseKey]
        // 联系人提取他的名字
        if (Array.isArray(chooseFromValue)) {
          if (chooseFromValue[0] && (chooseFromValue[0].userId || chooseFromValue[0].realname || chooseFromValue[0].name)) {
            chooseFromValue = chooseFromValue.map(user => { return user.userId || user.realname || chooseFromValue[0].name }).join()
          }
        }
        return chooseFromValue && (chooseFromValue === fromArr || chooseFromValue === fromKeyArr)
      })
    }
    if (condition.length > 0) {
      for (const s of field) {
        let val = condition.map(its => its[datatype === 2 ? (s.revisabilityName || s.name) : s.fatherType])
        if (val && val.length > 0 && Array.isArray(val) && Array.isArray(val[0]) && val[0][0] && (val[0][0].response || val[0][0].userId)) {
          val = val[0]
        }
        fromdatas[i][datatype === 2 ? (s.revisabilityName || s.name) : s.fatherType] = s.type !== 'image' && s.type !== 'file' && s.type !== 'relation-user' ? (val && Array.isArray(val) && val[0] && val[0].response ? val : (val).filter(it => it).join(',')) : val
      }
    }
  }
  return fromdatas
}

// 固定宽度模式宽度设置
export const fixedWidth = (val, config) => {
  const wArr = JSON.parse(JSON.stringify(config.selectDatas))
  if (val === 'default') {
    const obj = {
      file: 250,
      img: 250
    }
    // 默认则根据类型给宽度
    wArr.forEach(its => {
      its.width = obj[its.type] || 170
    })
  } else {
    // 556 是所有出宽度外的加起来的
    const innerW = window.innerWidth - 556
    const w = Math.round(innerW / config.selectDatas.length / innerW * 100)
    // 有操作按钮的话，还需要计算操作按钮的宽度
    // 固定宽度直接用总数计算百分比给宽度
    wArr.forEach(its => {
      its.width = w
    })
  }
  return wArr
}

// 权限列
export const purviewObj = {
  11: 'approvalid',
  1: 'myreportformid',
  2: 'myreportformid',
  3: 'myreportformid',
  4: 'myreportformid',
  5: 'myreportformid',
  6: 'scopeid',
  7: 'reportFormid',
  8: 'uncompleteid',
  12: 'approvalid',
  14: 'reportFormid',
  16: 'reportFormid',
  18: 'reportFormid',
  15: 'myreportformid',
  17: 'myreportformid',
  13: 'myreportformid',
  100: 'reportFormid'
}

// 地图要修改的备忘
// 1、选择区域配置的情况下 title 有设置标题则使用标题，没有设置标题则使用 row 字段
// 2、区域需要一次统计，根据配置匹配字段的地图 adcode 进行分组合并计算 summary 的值

/*
*  地图格式生成（后台）
* date 接口回来的数据集
* row 经纬度
* column 显示标题
* summary 汇总字段
* config 针对地图的配置
* **/
export const mapBackend = ({date, row, column, summary, config}) => {
  let ars = []
  const lgObj = {}
  switch (config.match) {
      case 'lg':
      for (const i of date) {
          const title = []
          for (const a of column) {
              title.push(i[a.revisabilityName])
          }
          const obs = {
              position: [],
              title: title.join(''),
              content: []
          }
          for (const a of row) {
              obs.position.push(i[a.revisabilityName])
          }
          for (const a of summary) {
              obs.content.push(i[a.name])
          }
          const e = lgObj[JSON.stringify(obs.position)]
          if (e) {
              ars[e.index].content = obs.content.reduce((acc, cur, i) => { 
                  acc.push(cur + ars[e.index].content[i]);
                  return acc;
              }, []);
              ars[e.index].title = obs.title
          } else {
              ars.push(obs)
              lgObj[JSON.stringify(obs.position)] = {
                  index: ars.length - 1,
                  ...obs
              }
          }
      }
      break
      case 'name':
        console.log('这个逻辑待定')
        for (const i of date) {
          const key = row.map(its => its.revisabilityName || its.name).join('')
          if (config.matchConfig[i[key]] || config.matchConfig[i[key]] === 0) {
          // 区域
          if (config.type === 'area') {
              ars.push({
              label: i[key],
              title: (column && column.length > 0 ? column : row).map(its => i[its.revisabilityName || its.name]).join(''),
              content: summary.map(its => i[its.name]),
              ...config.matchConfig[i[key]]
              })
          } else {
              ars.push({
              label: i[key],
              title: (column && column.length > 0 ? column : row).map(its => i[its.revisabilityName || its.name]).join(''),
              content: summary.map(its => i[its.name]),
              ...config.matchConfig[i[key]],
                  position: [config.matchConfig[i[key]].l, config.matchConfig[i[key]].g]
              })
          }
          }
        }
      break
  }
  // 如果配置是 区域或者名称的匹配，需要再计算一次汇总显示数据,以 adcode 字段为准
  if (config.type === 'area' && config.match === 'name') {
      const arsObj = {}
      for (const i of ars) {
      // 如果是相同 adcode 结构数据进行一次合并
      if (i.adcode && arsObj[i.adcode]) {
          if (Array.isArray(arsObj[i.adcode].content)) {
          for (let s = 0; s < arsObj[i.adcode].content.length; s++) {
              const vs = arsObj[i.adcode].content[s]
              const contents = Number(vs) + Number(i.content[s])
              arsObj[i.adcode].content[s] = !isNaN(contents) ? contents : (vs + i.content[s])
          }
          } else {
          const contents = Number(arsObj[i.adcode].content) + Number(i.content)
          arsObj[i.adcode].content = !isNaN(contents) ? contents : (arsObj[i.adcode].content + i.content)
          }
      } else {
          arsObj[i.adcode] = i
      }
      }
      ars = Object.values(arsObj)
  }

  for (let i = 0; i < ars.length; i++) {
      const cont = summary.map((ite, a) => {
          return ars[i].content[a] || ars[i].content[a] === 0 ? (ite.name + ':' + ars[i].content[a]) : ''
      })
      ars[i].content = cont
      // ars[i].content = config.match === 'name' ? cont.join('/n') : cont
  }
  return ars
}

// 地图格式生成 （客户端）
export const mapClient = ({date, row, column, summary, config}) => {
  let ars = []
  for (const i of date) {
      const position = []
      let title = []
      let content = []
      const ia = JSON.parse(JSON.stringify(i))
      let iaCount = {}
      // 删掉 row 相关配置
      for (const a of row) {
          delete ia[a.revisabilityName || a.name]
      }
      for (const a in ia) {
          if (ia[a] || ia[a] === 0) {
              const str = a.split(/\1{1}/g)
              for (let ss = 0; ss < str.length; ss++) {
                if (column[ss] && str[ss] && column[ss].type === 'date' && column[ss].format && column[ss].format === 'yyyy-MM-dd EEE') {
                  str[ss] = str[ss] + ' 星期' + getWeek(str[ss])
                }
              }
              title = str.slice(0, column.length)
              if (iaCount[str[str.length - 1]]) {
                  content[iaCount[str[str.length - 1]].index] = ia[a] + iaCount[str[str.length - 1]].val
                  iaCount[str[str.length - 1]] = { index: content.length - 1, val: ia[a] + iaCount[str[str.length - 1]].val }
              } else {
                  content.push(ia[a])
                  iaCount[str[str.length - 1]] = { index: content.length - 1, val: ia[a] }
              }
          }
      }
      if (config.type === 'area') {
          const key = row.map(its => its.revisabilityName || its.name).join('')
          if (config.match === 'lg') {
              ars.push({
                  position: (row || []).map(its => i[its.revisabilityName || its.name]),
                  title: title.join(''),
                  content: content
              })
          } else {
              if (config.matchConfig && (config.matchConfig[i[key]] || config.matchConfig[i[key]] === 0)) {
              ars.push({
                  ...config.matchConfig[i[key]],
                  label: i[key],
                  title: title.join(''),
                  content: content
              })
              }
          }
      } else {
      for (const a of row) {
          if (config.match === 'name') {
          const key = a.revisabilityName || a.name
          if (config.matchConfig && (config.matchConfig[i[key]] || config.matchConfig[i[key]] === 0)) {
              position.push(config.matchConfig[i[key]].l)
              position.push(config.matchConfig[i[key]].g)
          }
          } else {
          position.push(i[a.revisabilityName])
          }
      }
      const obs = {
          position: position,
          title: title.join(''),
          content: content
      }
      ars.push(obs)
      }
  }
  
  if (config.type === 'area' && config.match === 'name') {
      const arsObj = {}
      for (const i of ars) {
      // 如果是相同 adcode 结构数据进行一次合并
      if (i.adcode && arsObj[i.adcode]) {
          if (Array.isArray(arsObj[i.adcode].content)) {
          for (let s = 0; s < arsObj[i.adcode].content.length; s++) {
              const vs = arsObj[i.adcode].content[s]
              const contents = Number(vs) + Number(i.content[s])
              arsObj[i.adcode].content[s] = !isNaN(contents) ? contents : (vs + i.content[s])
          }
          } else {
          const contents = Number(arsObj[i.adcode].content) + Number(i.content)
          arsObj[i.adcode].content = !isNaN(contents) ? contents : (arsObj[i.adcode].content + i.content)
          }
      } else {
          arsObj[i.adcode] = i
      }
      }
      ars = Object.values(arsObj)
  }

  for (let i = 0; i < ars.length; i++) {
      const cont = summary.map((ite, a) => {
          return ars[i].content[a] || ars[i].content[a] === 0 ? (ite.name + ':' + ars[i].content[a]) : ''
      })
      ars[i].content = cont
  }

  return ars
}

// 矩形树图格式生成（后台）
export const treemapBackend = ({data, row, column, summary}) => {
  console.log(column, 'column')
  const c1 = {}
  for (const i of data) {
      for (const r of row) {
          const key = i[r.revisabilityName || r.name]
          if (c1[key]) {
              for (const s of summary) {
                  const sKey = s.name || s.revisabilityName
                  c1[key][sKey] += i[sKey]
              }
              c1[key].children.push(i)
          } else {
              if (!c1[key]) c1[key] = { label: key, children: [] }
              for (const s of summary) {
                  const sKey = s.name || s.revisabilityName
                  c1[key][sKey] = i[sKey]
              }
              c1[key].children.push(i)
          }
      }
  }
  return Object.values(c1)
}

// 矩形树图格式生成（客户端）
export const treemapClient  = ({list, row, column, summary, cols}) => {
  const c1 = {}
  console.log(summary, 'summary')
  for (const i of list) {
      for (const r of row) {
          const key = i[r.revisabilityName || r.name]
          // 使用数据另存出来，不影响源数据
          const li = JSON.parse(JSON.stringify(i))
          if (!c1[key]) c1[key] = { label: key, children: [] }
          delete li[r.revisabilityName || r.name]
          const obs = {}
          for (const ii in li) {
              // 这里要重新做一个配置结构，根据分解的第一次数据来
              const iiKey = ii.split(/\1{1}/g)
              if (column && column.length > 0) {
                for (let ss = 0; ss < iiKey.length; ss++) {
                  if (column[ss] && iiKey[ss] && column[ss].type === 'date' && column[ss].format && column[ss].format === 'yyyy-MM-dd EEE') {
                    iiKey[ss] = iiKey[ss] + ' 星期' + getWeek(iiKey[ss])
                  }
                }
                  if (!obs[iiKey[0]]) {
                      obs[iiKey[0]] = {}
                  }
                  for (const [ci, c] of (column || []).entries()) {
                      obs[iiKey[ci]][c.revisabilityName || c.name] = iiKey[ci]
                  }
                  obs[iiKey[0]][iiKey[iiKey.length - 1]] = li[ii]
              }
              if (cols[ii]) {
                  c1[key][iiKey[iiKey.length - 1]] = (c1[key][iiKey[iiKey.length - 1]] || 0) + cols[ii]
              }
          }
          c1[key].children = c1[key].children.concat(Object.values(obs))
      }
  }
  return Object.values(c1)
}

export function objectToTree(obj, options = {}) {
  const {
    childrenKey = 'children',
    valueKey = 'value',
    level = 0,
    maxDepth = 10,
    customOptions = {},
    allDatas = [],
    isDetailed = false,
    config = {},
    formula = [],
    addFormulaArr = [],
    parentPath = customOptions.name,
    hideField = [],
    sortConfig = []
  } = options

  // 防止无限递归
  if (level > maxDepth) {
    return []
  }
  const checkTypeList = customOptions.checkTypeList || []
  const typeKey = {}
  for (const ele of checkTypeList) {
    const filed = allDatas.find(item => item.title === ele.title)
    if (filed && filed.sels) {
      ele.sels = filed.sels
    }
    typeKey[ele.otherName] = ele
  }

  let tree = []

  for (const [key, value] of Object.entries(obj)) {
    const currentNodePath = parentPath ? `${parentPath}.${key}` : key;
    let isHide = false
    if (hideField.length !== 0) {
      isHide = hideField.includes(key)
    }
    if (isDetailed && config.isTodoList) {
      const nodes = []
      const target = formula.find(item => item.name === key)
      const addFormula = addFormulaArr.find(item => item.name === key) || {}
      if (target && (target.changeField.includes('radio') || target.changeField.includes('checkbox')) && target.checkType === 'check') {
        let filedInfo = target.filedInfo
        const [title, type] = target.changeField.split('_')
        if (!filedInfo) {
          filedInfo = target.appInfo.allData.find(f => f.title === target.changeField.split('_')[0])
        }
        for (const ele of filedInfo.sels) {
          const obj = {
            ...customOptions,
            level: level,
            title: `${title}_${ele.value}`,
            name1: ele.label,
            name: ele.label,
            label: ele.label,
            value: ele.value,
            customType: 'options',
            otherName: key,
            type: type,
            target,
            addFormula,
            path: currentNodePath,
            isHide
          }
          nodes.push(obj)
        }
        tree.push(...nodes)
      } else {
        const node = {
          ...customOptions,
          addFormula,
          level: level,
          title: key,
          name1: key,
          name: key,
          revisabilityName: key,
          customType: 'custom',
          path: currentNodePath,
          isHide
        }

        if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          // 如果值是对象，递归处理
          const children = objectToTree(value, {
            ...options,
            ...customOptions,
            level: level + 1,
            maxDepth,
            title: key,
            name1: key,
            name: key,
            revisabilityName: key,
            customType: 'custom',
            formula,
            config,
            isDetailed,
            addFormulaArr,
            parentPath: currentNodePath,
            hideField,
            sortConfig
          })

          if (children && children.length > 0) {
            node[childrenKey] = children
          } else {
            // 如果子节点为空，直接存储值
            node[valueKey] = value
          }
        } else {
          // 如果是基本类型值，直接存储
          node[valueKey] = value
        }

        tree.push(node)
      }
    } else {
      const field = typeKey[key]
      const nodes = []
      if (field && field.checkType === 'check' && field.sels) {
        for (const ele of field.sels) {
          const obj = {
            ...customOptions,
            level: level,
            title: `${field.title}_${ele.value}`,
            name1: ele.label,
            name: ele.label,
            label: ele.label,
            value: ele.value,
            newTitle: `${field.title}`,
            customType: 'options',
            otherName: key,
            type: field.type,
            path: currentNodePath,
            isHide
          }
          nodes.push(obj)
        }
        tree.push(...nodes)
      } else {
        const node = {
          ...customOptions,
          level: level,
          title: key,
          name1: key,
          name: key,
          revisabilityName: key,
          customType: 'custom',
          path: currentNodePath,
          isHide
        }

        if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          // 如果值是对象，递归处理
          const children = objectToTree(value, {
            ...options,
            ...customOptions,
            level: level + 1,
            maxDepth,
            title: key,
            name1: key,
            name: key,
            revisabilityName: key,
            customType: 'custom',
            parentPath: currentNodePath,
            hideField,
            sortConfig
          })

          if (children && children.length > 0) {
            node[childrenKey] = children
          } else {
            // 如果子节点为空，直接存储值
            node[valueKey] = value
          }
        } else {
          // 如果是基本类型值，直接存储
          node[valueKey] = value
        }

        tree.push(node)
      }
    }
  }
  if (sortConfig.length !== 0) {
    tree = tree.sort((a, b) => {
      const idxA = sortConfig.indexOf(a.name)
      const idxB = sortConfig.indexOf(b.name)
      if (idxA > -1 && idxB > -1) {
        return idxA - idxB
      } else if (idxA > -1) {
        return -1
      } else if (idxB > -1) {
        return 1
      } else {
        return 0
      }
    })
  } else {
    tree = sortObjectsByField(tree, 'name1')
  }
  return tree
}
